module.exports = __webpack_public_path__ + "fonts/AudiType-WideLight_4.03.309710e2.woff2";